import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./header.css";

function Navigation({ onNavigate, isOpen, useGlass }) {
  const getLinkClass = ({ isActive }) =>
    isActive ? "selectedlink" : "notselectedlink";

  const handleClick = () => {
    if (typeof onNavigate === "function") {
      onNavigate();
    }
  };

  const navClasses = ["nav-links"];
  if (useGlass) {
    navClasses.push("glass-panel");
  }
  if (isOpen) {
    navClasses.push("nav-links-open");
  }

  return (
    <nav
      id="primary-navigation"
      className={navClasses.join(" ")}
    >
      <ul>
        <li>
          <NavLink to="/fave" className={getLinkClass} onClick={handleClick}>
            Current Fave
          </NavLink>
        </li>
        <li>
          <NavLink to="/archive" className={getLinkClass} onClick={handleClick}>
            Fave Archive
          </NavLink>
        </li>
        <li>
          <NavLink to="/search" className={getLinkClass} onClick={handleClick}>
            Search
          </NavLink>
        </li>
        <li>
          <NavLink to="/how" className={getLinkClass} onClick={handleClick}>
            How This Works
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [viewportWidth, setViewportWidth] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth : 0
  );
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (typeof window === "undefined") {
        return;
      }
      setViewportWidth(window.innerWidth);
      if (window.innerWidth >= 1000) {
        setMenuOpen(false);
      }
    };

    const handleScroll = () => {
      if (typeof window === "undefined") {
        return;
      }
      setIsScrolled(window.scrollY > 8);
    };

    handleResize();
    handleScroll();

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isMobileLayout = viewportWidth < 1000;

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);
  const mobileTitle =
    viewportWidth && viewportWidth <= 600
      ? "I.W.K."
      : "Invest with Knowledge";
  const mobileHeaderClasses = ["mobile-header"];
  if (isScrolled || menuOpen) {
    mobileHeaderClasses.push("mobile-header-scrolled", "glass-panel");
  }
  const navShouldBeGlass = isMobileLayout && (menuOpen || isScrolled);

  return (
    <section className="header">
      <div className={mobileHeaderClasses.join(" ")}>
        <Link to="/fave" className="mobile-title" aria-label="View Current Fave">
          {mobileTitle}
        </Link>
        <button
          className={`menu-toggle${menuOpen ? " expanded" : ""}`}
          aria-controls="primary-navigation"
          aria-expanded={menuOpen}
          onClick={toggleMenu}
          type="button"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
      <h1 className="LargeH1 desktop-title">
        <Link to="/fave" aria-label="View Current Fave">Invest With Knowledge!</Link>
      </h1>
      <Navigation
        onNavigate={closeMenu}
        isOpen={menuOpen}
        useGlass={navShouldBeGlass}
      />
    </section>
  );
}

export default Header;
